import { useCallback, useEffect, useState } from "react";

const useBrowserNotifications = () => {
  const [isSupported, setIsSupported] = useState(false);
  const [permission, setPermission] = useState("default");

  useEffect(() => {
    if (typeof window === "undefined") return;

    const supported = "Notification" in window;
    setIsSupported(supported);

    if (supported) {
      setPermission(window.Notification.permission);
    }
  }, []);

  
  const requestPermission = useCallback(async () => {
    if (!isSupported) {
      return { granted: false, reason: "unsupported" };
    }

    // If already granted/denied, just reflect the current state
    if (permission === "granted") {
      return { granted: true };
    }
    if (permission === "denied") {
      return { granted: false, reason: "denied" };
    }

    try {
      const result = await window.Notification.requestPermission();
      setPermission(result);
      return { granted: result === "granted" };
    } catch {
      // If anything goes wrong, treat as not granted
      setPermission("denied");
      return { granted: false, reason: "error" };
    }
  }, [isSupported, permission]);

  
  const showTestNotification = useCallback(
    (title = "Notifications enabled", options = {}) => {
      if (!isSupported) return;
      if (permission !== "granted") return;

      new window.Notification(title, {
        body: options.body,
        icon: options.icon,
        tag: options.tag,
      });
    },
    [isSupported, permission]
  );

  return {
    isSupported,
    permission, // "default" | "granted" | "denied"
    requestPermission,
    showTestNotification,
  };
};

export default useBrowserNotifications;

